module.exports = __webpack_public_path__ + "img/pasa.42212e93.svg";